// 共通APIクライアント
// 401/403/その他エラーの共通処理
const MSG_SESSION_EXPIRED = 'セッションの有効期限が切れました\n再度ログインしてください';
const MSG_FORBIDDEN = 'アクセス権限がありません';
const MSG_NOT_FOUND = 'ファイルが見つかりません';
const MSG_SERVER_ERROR = 'サーバエラーが発生しました';

// アラート多重表示抑止（バースト抑止方式）
// 同一イベントループ内/alert表示直後に連鎖する同種アラートは1回にまとめる。
// alertを閉じた後、次のユーザ操作で発生した新しいエラーは再び表示される。
let alertBurstActive = false;
const ALERT_BURST_CLEAR_DELAY_MS = 0; // 次tickで解除
function showAlertBurst(message) {
  if (alertBurstActive) return; // 既に表示中バースト: 抑止
  alertBurstActive = true;
  alert(message); // ブロッキング。閉じた後に setTimeout が実行され解除される
  setTimeout(() => { alertBurstActive = false; }, ALERT_BURST_CLEAR_DELAY_MS);
}

// API呼び出し
export async function authFetch(url, options = {}) {
  // アクセストークン取得
  const token = localStorage.getItem('accesstoken');
  // HTTPヘッダにAuthorizationヘッダを追加
  const headers = new Headers(options.headers || {});
  if (token && !headers.has('Authorization')) {
    headers.set('Authorization', `Bearer ${token}`);
  }
  // HTTPヘッダにアクション名を追加
  if (options.actionName) {
    headers.set('X-Action-Name', encodeURIComponent(options.actionName));
  }
  // API呼び出し
  const res = await fetch(url, { ...options, headers });
  if (!res.ok) {
    // デバッグ用ログ（必要に応じてコメントアウト可）
    if (process.env.REACT_APP_DEBUG_AUTH === '1') {
      console.error('[authFetch] NG', res.status, res.statusText, '=>', url);
    }
    // 認証エラー
    if (res.status === 401) {
      // バースト抑止アラート
      showAlertBurst(MSG_SESSION_EXPIRED);
      // アクセストークン削除（冪等）
      localStorage.removeItem('accesstoken');
      // リダイレクト（複数回評価されても影響小）
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    // 権限エラー
    else if (res.status === 403) {
      // バースト抑止アラート
      showAlertBurst(MSG_FORBIDDEN);
    }
    // ファイル未検出エラー
    else if (res.status === 404) {
      // バースト抑止アラート
      showAlertBurst(MSG_NOT_FOUND);
    }
    // リクエスト不正エラー
    else if (res.status === 400) {
      // 400エラーはクライアント側の問題なのでユーザに通知しない
      console.warn('リクエスト不正エラー');
    }
    // その他エラー：ステータスごとに一度だけ
    else {
      // バースト抑止アラート
      showAlertBurst(`HTTP ${res.status} ${res.statusText}\n${MSG_SERVER_ERROR}`);
    }
    // エラーを投げる
    const err = new Error(`HTTP ${res.status} ${res.statusText} @ ${url}`);
    // 失敗レスポンス本文を（JSON/テキストどちらでも）一度だけ試し取得
    try {
      const clone = res.clone();
      const text = await clone.text();
      if (text) err.details = text;
    } catch { /* ignore */ }
    throw err;
  }
  // 正常終了
  return res;
}

// JSONレスポンス取得
export async function authJson(url, options = {}) {
  const res = await authFetch(url, options);
  return res.json();
}

// Blobレスポンス取得
export async function authBlob(url, options = {}) {
  const res = await authFetch(url, options);
  return res.blob();
}

export { MSG_SESSION_EXPIRED, MSG_FORBIDDEN };
